// PrivacyPolicyMetaData.js
import React from 'react';
import { Helmet } from 'react-helmet-async';

export const PrivacyPolicyMetaData = () => {
  const schemaData = {
    "@context": "https://schema.org",
    "@graph": [
      {
        "@type": "WebPage",
        "@id": "https://www.meatbuddy.in/privacy-policy/#webpage",
        "url": "https://www.meatbuddy.in/privacy-policy",
        "name": "Privacy Policy - Meat Buddy",
        "description": "Read Meat Buddy's privacy policy. Learn how we collect, use, and protect your personal information when you use our meat delivery service.",
        "isPartOf": { "@id": "https://www.meatbuddy.in/#website" },
        "breadcrumb": {
          "@type": "BreadcrumbList",
          "itemListElement": [
            {
              "@type": "ListItem",
              "position": 1,
              "item": {
                "@id": "https://www.meatbuddy.in",
                "name": "Home"
              }
            },
            {
              "@type": "ListItem",
              "position": 2,
              "item": {
                "@id": "https://www.meatbuddy.in/privacy-policy",
                "name": "Privacy Policy"
              }
            }
          ]
        }
      },
      {
        "@type": "Article",
        "@id": "https://www.meatbuddy.in/privacy-policy/#article",
        "headline": "Meat Buddy Privacy Policy",
        "description": "Our commitment to protecting your privacy and personal information",
        "articleBody": "This privacy policy outlines how Meat Buddy collects, uses, and protects customer information",
        "publisher": {
          "@type": "Organization",
          "@id": "https://www.meatbuddy.in/#organization",
          "name": "Meat Buddy",
          "url": "https://www.meatbuddy.in"
        },
        "datePublished": "2025-03-01",
        "dateModified": "2025-03-01"
      },
      {
        "@type": "FAQPage",
        "@id": "https://www.meatbuddy.in/privacy-policy/#faq",
        "mainEntity": [
          {
            "@type": "Question",
            "name": "What personal information do you collect?",
            "acceptedAnswer": {
              "@type": "Answer",
              "text": "We collect name, contact details, delivery address, and payment information necessary for processing your orders."
            }
          },
          {
            "@type": "Question",
            "name": "How do you protect customer data?",
            "acceptedAnswer": {
              "@type": "Answer",
              "text": "We use industry-standard security measures and encrypted payment processing to protect your personal information."
            }
          },
          {
            "@type": "Question",
            "name": "Do you share customer information?",
            "acceptedAnswer": {
              "@type": "Answer",
              "text": "We never sell your personal information. We only share necessary details with delivery partners to fulfill your orders."
            }
          }
        ]
      }
    ]
  };

  return (
    <Helmet>
      <title>Privacy Policy - Meat Buddy | Your Data Protection Rights</title>
      <meta name="title" content="Privacy Policy - Meat Buddy | Fresh Meat Delivery Service" />
      <meta name="description" content="Learn how Meat Buddy protects your personal information while providing premium meat delivery services in Bengaluru. Read about our data collection, usage, and security practices." />
      <meta name="keywords" content="meat buddy privacy policy, data protection, personal information security, meat delivery privacy" />
      <meta name="robots" content="noindex, follow" />
      
      <meta property="og:type" content="website" />
      <meta property="og:url" content="https://www.meatbuddy.in/privacy-policy" />
      <meta property="og:title" content="Privacy Policy - Meat Buddy" />
      <meta property="og:description" content="Learn how we protect your personal information while providing premium meat delivery services in Bengaluru." />
      
      <meta name="twitter:card" content="summary" />
      <meta name="twitter:title" content="Privacy Policy - Meat Buddy" />
      <meta name="twitter:description" content="Read about our commitment to protecting your privacy and personal information." />
      
      <link rel="canonical" href="https://www.meatbuddy.in/privacy-policy" />
      
      {/* Security Headers */}
      <meta http-equiv="Content-Security-Policy" content="default-src 'self'" />
      <meta http-equiv="X-Content-Type-Options" content="nosniff" />
      <meta http-equiv="X-Frame-Options" content="DENY" />
      
      <script type="application/ld+json">{JSON.stringify(schemaData)}</script>
    </Helmet>
  );
};
  